module.exports = __webpack_public_path__ + "static/img/one.4c81e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/one.png
// module id = Jqw6
// module chunks = 1